import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function bansQueryOptions(storeId: string) {
  return infiniteQueryOptions({
    queryKey: chatSettingsKeys.bans(storeId),
    queryFn: ({ pageParam }) => chatSettingsApi.bans(storeId, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
}

/** Newest first; expired bans stay listed until someone lifts them. */
export function useBans(storeId: string, enabled = true) {
  return useInfiniteQuery({ ...bansQueryOptions(storeId), enabled });
}
